module.exports = __webpack_public_path__ + "static/img/未标题-2@2x.89eba311.png";